export default{
    title: 'dark',
    colors:{
        primary: '#2f333e',
        secundary: '#C62E65',
        text: 'white'
    },
    background: '#eaeaea',
    text: '#333'
}